import { connect } from 'react-redux'
import { getMe, updateProfile,fetchMe,updateUserToken } from '../../store/user/duck'
import UpdateProfileComponent from './component'

const UpdateProfileContainer = connect(
  // Map state to props
  state => ({
  	user: state.user.user,
  	userPhase: state.user.userPhase
  }),
  {
  	getMe,
    updateUserToken,
    fetchMe,
  	updateProfile
  }
)(UpdateProfileComponent)

export default UpdateProfileContainer
